import { SelectOption } from '@zencity/common-ui/lib/ZCD/ZCDFilter/types';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { getAnswersWordCloudData } from 'screens/WidgetGenerator/helpers/answersWordCloud';
import { ReportBuilderWidgetProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { WordCloudQuestionSentiment, WordCloudWidgetData } from 'screens/WidgetGenerator/utils/misc';
import { WordCloudChart } from 'screens/WidgetGenerator/widgets/WordCloud/WordCloud';
import { logger } from 'utils/logger';
import styles from './WordCloudHOC.module.scss';

const DEFAULT_WORD_CLOUD_DATA: WordCloudWidgetData = {
  positive: [],
  negative: [],
};

export const WordCloudHOC = (props: ReportBuilderWidgetProps): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);
  const [selectedGenericQuestionOption, setSelectedGenericQuestionOption] = useState<SelectOption>();
  const [wordCloudSentimentOptions, setWordCloudSentimentOptions] = useState<WordCloudQuestionSentiment[]>([
    WordCloudQuestionSentiment.POSITIVE,
    WordCloudQuestionSentiment.NEGATIVE,
  ]);
  const { params } = props;
  const { filters } = params;
  const showQuestionText = filters?.wordCloudShowQuestionText && selectedGenericQuestionOption;

  const fetchWordCloudData = async () => {
    const fetchedWordCloudData = await getAnswersWordCloudData(
      client,
      cycles,
      selectedDateRange,
      selectedGenericQuestionOption?.value as number,
    );
    return fetchedWordCloudData;
  };

  const {
    fetchedData: wordCloudData,
    isLoading,
    error,
  } = useAsyncEffect(fetchWordCloudData, [client, cycles, selectedDateRange, selectedGenericQuestionOption]);

  if (error) {
    logger.error(error);
  }

  useEffect(() => {
    if (filters?.wordCloudGenericQuestionSelect) {
      const selectedOption = filters.wordCloudGenericQuestionSelect;
      setSelectedGenericQuestionOption(selectedOption);
      setWordCloudSentimentOptions([WordCloudQuestionSentiment.OTHER]);
    }
  }, [filters]);

  return (
    <LoaderMask isLoading={isLoading}>
      {showQuestionText && <p className={styles.questionText}>{selectedGenericQuestionOption.label}</p>}
      <div className={styles.wordCloudContainer}>
        <WordCloudChart
          isValidData
          widgetData={wordCloudData ?? DEFAULT_WORD_CLOUD_DATA}
          sentimentDataTypes={wordCloudSentimentOptions}
          width={500}
          height={240}
        />
      </div>
    </LoaderMask>
  );
};
